// @ts-nocheck
/* eslint-enable */
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import usertiming from 'app/shared/utils/performanceUtils';

// Actions
import AppActions from 'app/shared/flux/actions/AppActions';

// Components
import BreadcrumbNav from 'app/shared/modules/BreadcrumbNav';
import AreaListingsContainer from 'app/shared/wrappers/AreaListingsContainer';
import Container from 'app/shared/core/Container';
import ListingHeader from 'app/shared/modules/ListingHeader';
import ExploreWrapper from 'app/shared/wrappers/ExploreWrapper';
import FilterPills from 'app/shared/modules/MobileSRP/ListingCards/FilterPills';
import FooterMarketingBlurb from 'app/shared/modules/navigation/footer/FooterMarketingBlurb';
import Footer from 'app/shared/modules/Footer';
import NearbyAreaListings from 'app/shared/modules/search-page/NearbyAreaListings';
import SeoFooter from 'app/shared/modules/SeoFooter';
import AreaHead from 'app/shared/modules/area/AreaHead';

// Misc / Utils
import searchSlugUtils from 'app/shared/utils/searchSlugUtils';
import { areaUtils_getSrpMaxPageLimit } from 'app/shared/utils/areaUtils';
import constants from 'app/shared/constants/ConstantsBundle';
import numberUtils from 'app/shared/utils/numberUtils';
import queryUtils from 'app/shared/utils/queryUtils';
import * as S from './areaPage.styles';
import DeferredHydration from 'app/shared/wrappers/DeferredHydration';

class AreaPage extends React.Component {
  static propTypes = {
    area: PropTypes.object,
    isMobile: PropTypes.bool,
    setMapView: PropTypes.func,
    showSkeletonPage: PropTypes.bool,
  };

  static defaultProps = {
    area: {},
    isMobile: false,
    setMapView: () => {},
    showSkeletonPage: false,
  };

  componentDidMount() {
    const { areaPageMaloneLotIdPosition, dispatch, isMobile } = this.props;

    // performance tracking
    usertiming.mark('AreaPage componentDidMount');

    if (areaPageMaloneLotIdPosition) {
      const scrollPosition = document.getElementById(areaPageMaloneLotIdPosition);

      if (scrollPosition) {
        if (isMobile) {
          document.documentElement.scrollTop = scrollPosition.offsetTop;
        } else {
          this.scrollTo(scrollPosition.offsetTop);
        }
      }

      // Erase scroll position whether or not the listing was found.
      dispatch(AppActions.setAreaPageScrollPosition(null));
    } else {
      this.scrollTo();
    }
  }

  scrollTo(scrollPosition = 0) {
    const sidebar = document.getElementById('SplitMapTemplate-right-sidebar');
    sidebar.scrollTop = scrollPosition;
  }

  renderMaxSrpPageLimitNotice() {
    const { area, page, totalListings } = this.props;
    const upperBound = page * constants.MAX_LISTINGS_PER_PAGE;
    const numListingsLeft = numberUtils.compact(totalListings - upperBound);
    const fullName = area.fullName;

    return (
      <Container>
        <S.AreaPageLimitingText>
          <S.DarkPageLimitNotice size="md">
            {`There are ${numListingsLeft} more listings in ${fullName}, please adjust your filters to see them`}
          </S.DarkPageLimitNotice>
        </S.AreaPageLimitingText>
      </Container>
    );
  }

  render() {
    const {
      showSkeletonPage,
      page,
      isMapView,
      isMobile,
      listings,
      listingsLoading,
      maxPage,
      pathname,
      setMapView,
      totalBuildings,
      searchSlug,
      totalListings,
      slugTitle,
    } = this.props;
    const pathnameSlug = searchSlugUtils.getSearchSlugFromUrl(pathname);
    const artificialMaxPageLimit = areaUtils_getSrpMaxPageLimit(maxPage, searchSlug);
    const shouldDisplayPageLimitNotice =
      artificialMaxPageLimit === constants.SRP_MAX_PAGE_LIMIT && page === artificialMaxPageLimit;
    const showMarketingBlurb = pathnameSlug === 'apartments-for-rent' || pathnameSlug === 'houses-for-rent';

    if (isMobile && isMapView) {
      return null;
    }

    return (
      <S.AreaPage id="AreaPage">
        <AreaHead />
        <Fragment>
          <ListingHeader
            searchSlug={searchSlug}
            slugTitle={slugTitle}
            totalListings={totalListings}
            currentPage={page}
            totalBuildings={totalBuildings}
            propertyType={'Apartments'}
            isDesktop
          />
          <AreaListingsContainer
            isSkeleton={showSkeletonPage}
            maxListingsPerPage={constants.MAX_LISTINGS_PER_PAGE}
            setMapView={setMapView}
          />
          {shouldDisplayPageLimitNotice &&
            !listingsLoading &&
            listings.length !== 0 &&
            this.renderMaxSrpPageLimitNotice()}
          {page === maxPage && !listingsLoading && listings.length !== 0 && (
            <Container>
              <FilterPills />
              <NearbyAreaListings />
            </Container>
          )}

          <Container>
            <BreadcrumbNav />
          </Container>
          <S.AreaPageDivider />
        </Fragment>
        <DeferredHydration name="area-page-footer">
          {page === 1 && <ExploreWrapper setMapView={setMapView} maxPage={maxPage} />}
          {showMarketingBlurb && <FooterMarketingBlurb />}
          <SeoFooter shortDivider={showMarketingBlurb} disableInternalMarketingBlurb={true} />
          <div>
            <Footer noMarginTop />
          </div>
        </DeferredHydration>
      </S.AreaPage>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const maxBuildings = state.listings.totalBuildings;

  return {
    area: state.area.area,
    areaPageMaloneLotIdPosition: state.app.areaPageMaloneLotIdPosition,
    isMobile: state.app.device.screenWidth === 'sm',
    listings: state.listings.listingGroups.byCoords,
    listingsLoading: !state.app.fetchListingsByCoordsComplete,
    maxPage: Math.max(Math.ceil(maxBuildings / constants.MAX_LISTINGS_PER_PAGE), 1),
    page: Number(queryUtils.parse(ownProps.location.search).page || 1),
    pathname: ownProps.location.pathname,
    propertyType: searchSlugUtils.preparePropertyType(state.filter.search.slug),
    query: queryUtils.parse(ownProps.location.search),
    searchSlug: state.filter.search.slug,
    slugTitle: state.filter.search.title,
    totalBuildings: maxBuildings,
    totalListings: state.listings.totalListings,
  };
};

export default withRouter(connect(mapStateToProps)(AreaPage));
